<template>
  <el-row class="editor-list-header">
    <el-col class="order" :span="1">
      <span class="inside">句段</span>
    </el-col>
    <el-col class="source" :span="10">原文</el-col>
    <el-col class="target" :span="11">译文</el-col>
    <el-col class="condition" :span="1">
      <span class="inside">状态</span>
    </el-col>
    <el-col class="annotation" :span="1">
      <span class="inside">备注</span>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: "TableHeader"
  }
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>